import api from './api';

export const authService = {
  register: async (data) => {
    const response = await api.post('/tutor/register', data);
    if (response.data.success) {
      localStorage.setItem('tutorToken', response.data.data.token);
      localStorage.setItem('tutorData', JSON.stringify(response.data.data.user));
    }
    return response.data;
  },

  login: async (email, password) => {
    const response = await api.post('/tutor/login', { email, password });
    if (response.data.success) {
      localStorage.setItem('tutorToken', response.data.data.token);
      localStorage.setItem('tutorData', JSON.stringify(response.data.data.user));
    }
    return response.data;
  },

  logout: async () => {
    try {
      await api.post('/tutor/logout');
    } finally {
      localStorage.removeItem('tutorToken');
      localStorage.removeItem('tutorData');
    }
  },

  getMe: async () => {
    const response = await api.get('/tutor/me');
    if (response.data.success) {
      localStorage.setItem('tutorData', JSON.stringify(response.data.data));
    }
    return response.data;
  },
};
